import React  from 'react'
import { components } from 'cng-web-lib'

import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import pathMap from 'src/paths/pathMap'
import MGTTApiUrls from 'src/apiUrls/MGTTApiUrls'

const {
  form: { CngAddForm }
} = components

function AddPage({ history, showNotification }) {
 
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngAddForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          history={history}
          showNotification={showNotification}
          bodySection={
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
            />
          }
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          create={{
            url: MGTTApiUrls.CREATE_ADMIN_CONFIG,//data place here - data.moduleURL
            successRedirect: pathMap.MGTT_ADMIN_CONFIG_LIST_VIEW
          }}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage
